import React, { useEffect, useState } from 'react'
import './App.css';
import Login from './components/Login';
import Home from './components/Home';
import Spinner from './components/Spinner';
import {jwtDecode} from 'jwt-decode';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [token, setToken] = useState("");

  const isTokenExpired = () => {
    if (!token) return true;
    try {
      let decodedToken = jwtDecode(token);
      let currentTime = Date.now() / 1000;
      return decodedToken.exp < currentTime;
    } catch (error) {
      //console.error('Error decoding token:', error);
      return true;
    }
  };
  
  useEffect(() => {
    
    if (token) {
      //const token = localStorage.getItem('vendorToken');
      if (isTokenExpired()) {
        //localStorage.removeItem('vendorToken');
        setIsLoggedIn(false);
      } else {
        //setLoading(false);
        setIsLoggedIn(true);
      }
    } else {
      setIsLoggedIn(false);
    }

  },[])
  
  function updateIsLoggedIn(answer){
    setIsLoggedIn(answer)
  } 
  
  return (
    <>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      { isLoggedIn ? <Home isTokenExpired={isTokenExpired} setIsLoggedIn={setIsLoggedIn} token={token} /> : <Login spinner={spinner} setSpinner={setSpinner} setToken={setToken} setIsLoggedIn={setIsLoggedIn} /> }
      {spinner && <Spinner />}
    </>
  )

}

export default App;